export default __webpack_public_path__ + "static/media/be.79feee8d.svg";